"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiAcceptorForm = void 0;
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./MultiAcceptorForm.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var MultiAcceptorForm = function (props) {
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("div", { className: styles.fieldMappingInfo },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "Field Mapping"),
            react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" }, "Choose which custom forms inputs you want to write to HubSpot deal fields. Add more accepters if you wish to map inputs for multiple accepters.")),
        react_1.default.createElement("div", { className: styles.multiAcceptorForm },
            react_1.default.createElement(kaleidoscope_1.Text, null, "Multiacceptor form goes here"))));
};
exports.MultiAcceptorForm = MultiAcceptorForm;
